import React from 'react';
import BaseTab from '@mui/material/Tab';

const Tab = (props) => <BaseTab {...props} />;

export default Tab;
